/* eslint-disable react-hooks/exhaustive-deps */
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as HERBUI from "react-bootstrap";
import "./loginandlandingpage.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import LoginPage from "./containers/Login";
import Dashboard from "./containers/Dashboard";
import Loader from "./reducers/Loader";
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, createStore } from "redux";
import SpinnerReducers from "./reducers/SpinnerReducer";
import thunk from "redux-thunk";
import axios from "axios";
import Swal from "sweetalert2";
import { LOGIN_PAGE_URL } from "./Api/APIURLS";
import ForgotPassword from "./containers/ForgotPassword";
import Gos from "./containers/Gos";
import Footer from "./containers/Footer";
import LogOut from "./utils/LogOut";
import PresidentialOrder from "./containers/PresidentialOrder";
import KnowYourCfmsId from "./containers/KnowYourCfmsId";
import BudgetRelatedPdfDetails from "./containers/BudgetRelatedPdfDetails";
import LoginPageAuthentication from "./containers/LoginPage";
import UserManuals from "./containers/UserManuals";
import MobileApp from "./containers/MobileApp";
import ServiceAssociationMain from "./containers/ServiceAssociationMain";
// import SearchComponent from "./containers/SearchComponent";
import LoginPageDev from "./containers/LoginPageDev";
import { useEffect } from "react";
import AppStateReducer from "./reducers/AppStateReducer";
import NidhiUserManuals from "./containers/NidhiUserManuals";
import PO2025Repository from "./containers/PresidentialOrder";
import LoginPageUpdated from "./containers/LoginPageUpdated";
import ChangePassword from "./containers/ChangePassword";


const reducer = combineReducers({
  spinner: SpinnerReducers,
  app: AppStateReducer,

});
const store = createStore(reducer, applyMiddleware(thunk));
const { dispatch } = store;
axios.interceptors.request.use(function (config) {
  dispatch({ type: 'SHOW_SPINNER' });
  return config;
}, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  dispatch({ type: 'HIDE_SPINNER' });
  return response;
}, function (error) {

  return Promise.reject(error);
})
const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={props => {
      if (localStorage.getItem('token') !== null) {
        return <Component  ></Component>;
      }
      else {

        Swal.fire({
          text: "UnAuthorised Access",
          icon: 'error',
          confirmButtonColor: '#4962B3',
          confirmButtonText: 'Ok'
        }).then(function () {
          window.location.href = LOGIN_PAGE_URL
        });
      }
    }
    } />
  );
};


function App() {

  useEffect(() => {
    const removeCookies = () => {
      const data1 = "disable detailssssssssssssssssssssssssss";
      const data2 = "where is train";
      document.cookie = `myCookie1=${data1}; path=/; max-age=3600`;  // Set first cookie
      document.cookie = `myCookie2=${data2}; path=/; max-age=3600`;  // Set second cookie


      // Now, remove the cookies
      const cookies = document.cookie.split(';');
      cookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();
        // Remove the cookie by setting an expired date in the past
        document.cookie = `${cookieName}=; expires=${new Date(0).toUTCString()}; path=/;`;

      });

      // Logs after deletion

    };

    // Run the function to remove cookies
    removeCookies();
  }, []);
  return (
    <>
      <Provider store={store}>
        <HERBUI.Container fluid>
          <Router>
            <Switch>
              <Route path="/login">
                <LoginPage />
                {/* <LoginPageAuthentication /> */}
              </Route>
              <Route path="/serviceassociation">
                <ServiceAssociationMain />
              </Route>
              {/* <Route path="/69d17eb8fccce572d0ec63e721b250a6"> */}
              <Route path="/c56b07a3e8f2f83473fd88c672354cd3">
                <LoginPage />
                {/* <LoginPageAuthentication /> */}
              </Route>
              <Route path="/loginPage">
                <LoginPageAuthentication />
              </Route>
              <Route path="/loginPageUpdated">
                <LoginPageUpdated />
              </Route>
              <Route path="/changePassword">
                <ChangePassword />
              </Route>
              <Route path="/loginOtpDev">
                <LoginPageDev />
              </Route>
              <PrivateRoute path="/dashboard">
                <Dashboard />
              </PrivateRoute>
              <Route path="/forgotPassword">
                <ForgotPassword />
              </Route>
              <Route path="/KnowYourCfmsId">
                <KnowYourCfmsId />
              </Route>
              <Route path="/PresidentialOrder">
                <PO2025Repository />
              </Route>
              <Route path="/Gos">
                <Gos />
              </Route>
              <Route path="/budgetRelatedPdfDetails">
                <BudgetRelatedPdfDetails />
              </Route>
               <Route path="/nidhiUserManuals">
                <NidhiUserManuals />
              </Route>

              <Route path="/usermanuals">
                <UserManuals />
              </Route>
              <Route path="/nidhiUserManuals">
                <NidhiUserManuals />
              </Route>
              <Route path="/mobileApp">
                <MobileApp />
              </Route>
              {/* <Route path="/search">
                <SearchComponent />
              </Route> */}
              <Route path="/logOut">
                <LogOut />
              </Route>
              <Route path="*">
                <LoginPage />
                {/* <LoginPageAuthentication /> */}
              </Route>
            </Switch>
          </Router>
          <Loader />
          <Footer />
        </HERBUI.Container>
      </Provider>
    </>
  );
}

export default App;
